'use client';
import React from 'react';
import AppLink from '@/components/next-ui/Link/Link';
import { Disclosure } from '@headlessui/react';
import Avatar from '@ui/Avatar';
import FadeTransition from '@ui/Transitions/FadeTransition';
import Typography from '@ui/Typography';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import ExpandableList from '@/components/ExpandableList';

const getNonProfitLocation = (nonProfit) => {
  const location = [];
  if (nonProfit.city) {
    location.push(nonProfit.city);
  } else if (nonProfit.state) {
    location.push(nonProfit.state);
  }
  if (nonProfit.country) {
    location.push(nonProfit.country);
  }
  return location.join(', ');
};

function NpoList(props) {
  const {
    title = 'Nonprofits Supported',
    nonProfits,
    expanded = false,
  } = props;

  const renderAllNonProfits = () => {
    return (
      <>
        {nonProfits.map((nonProfit) => (
          <div className="flex items-center gap-4" key={nonProfit.id}>
            <div className="shrink-0 grow-0">
              <Avatar
                src={nonProfit.logo_url}
                alt={nonProfit.name}
                profile="npo"
                size="sm"
              />
            </div>
            <div className="flex flex-1 flex-col items-start justify-between">
              <AppLink href={`/${nonProfit.slug}`}>
                <Typography
                  variant="subtitle1"
                  className="group-hover:text-text-hyperlink">
                  {nonProfit.name}
                </Typography>
              </AppLink>
              <Typography variant="body1" color="textSecondary">
                {getNonProfitLocation(nonProfit)}
              </Typography>
            </div>
          </div>
        ))}
      </>
    );
  };

  return (
    <Disclosure defaultOpen={expanded}>
      {({ open }) => (
        <>
          <Disclosure.Button className="flex w-full items-center justify-between">
            <div className="flex items-center justify-start gap-4">
              <Typography variant="h3">{title}</Typography>
            </div>
            <MdOutlineKeyboardArrowDown
              className={`${
                open ? 'rotate-180 transform' : ''
              } h-5 w-5 text-text-secondary`}
            />
          </Disclosure.Button>
          <FadeTransition>
            <Disclosure.Panel className="flex flex-col gap-4">
              {nonProfits.length === 0 && (
                <div className="flex flex-1 items-center justify-start">
                  <Typography variant="h4" color="textDisabled">
                    No nonprofits supported yet
                  </Typography>
                </div>
              )}

              {/* {nonProfits.map((nonProfit) => (
                <div className="flex items-center gap-4" key={nonProfit.id}>
                  <div className="shrink-0 grow-0">
                    <Avatar
                      src={nonProfit.logo_url}
                      alt={nonProfit.name}
                      profile="npo"
                      size="sm"
                    />
                  </div>
                  <div className="flex flex-1 flex-col items-start justify-between">
                    <AppLink href={`/${nonProfit.slug}`}>
                      <Typography
                        variant="subtitle1"
                        className="group-hover:text-text-hyperlink">
                        {nonProfit.name}
                      </Typography>
                    </AppLink>
                    <Typography variant="body1" color="textSecondary">
                      {getNonProfitLocation(nonProfit)}
                    </Typography>
                  </div>
                </div>
              ))} */}

              <ExpandableList items={renderAllNonProfits()} />
            </Disclosure.Panel>
          </FadeTransition>
        </>
      )}
    </Disclosure>
  );
}

export default NpoList;
